export class  Service {
    id: string = null;
    description?: string;
    status: "active" | "inactive" | "archived";
    title: string;

    constructor (init: Partial<Service>) {
        Object.assign(this, init);
    }
}